'use client';

import { c as _c } from "react/compiler-runtime";
import { useGetMarketsField, useMarketConfig, useMarketResolutionThreshold } from '@morfi/backend-sdk-v2/client';
import { type Context, createContext, type ReactNode, useContext } from 'react';
const FeedMarketThresholdContext: Context<string | null | undefined> = createContext<string | null | undefined>(undefined);
export function FeedMarketThresholdProvider(props) {
  const $ = _c(13);
  const {
    pubkey,
    children
  } = props;
  const config = useMarketConfig(useGetMarketsField(pubkey, "marketConfig"));
  const status = useGetMarketsField(pubkey, "status");
  const outcomeCount = useGetMarketsField(pubkey, "outcomeCount");
  const tradingStartedAt = useGetMarketsField(pubkey, "tradingStartedAt");
  const resolvedAt = useGetMarketsField(pubkey, "resolvedAt");
  const t0 = status ?? "created";
  const t1 = Number(outcomeCount ?? 0);
  const t2 = tradingStartedAt ?? null;
  const t3 = resolvedAt ?? null;
  let t4;
  if ($[0] !== config || $[1] !== pubkey || $[2] !== t0 || $[3] !== t1 || $[4] !== t2 || $[5] !== t3) {
    t4 = {
      marketPubkey: pubkey,
      config,
      status: t0,
      outcomeCount: t1,
      tradingStartedAt: t2,
      resolvedAt: t3
    };
    $[0] = config;
    $[1] = pubkey;
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const threshold = useMarketResolutionThreshold(t4);
  let t5;
  if ($[7] !== threshold.kind || $[8] !== threshold.thresholdPpb) {
    t5 = threshold.kind === "ready" ? threshold.thresholdPpb.toString() : null;
    $[7] = threshold.kind;
    $[8] = threshold.thresholdPpb;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== t5) {
    t6 = <FeedMarketThresholdContext.Provider value={t5}>{children}</FeedMarketThresholdContext.Provider>;
    $[10] = children;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}
export function useFeedMarketThreshold() {
  const threshold = useContext(FeedMarketThresholdContext);
  if (threshold === undefined) {
    throw new Error("Feed market threshold requires FeedMarketThresholdProvider");
  }
  return threshold;
}